// extracted by mini-css-extract-plugin
export default {"cls1":"InviteRegisterTOTP-TextFieldContainer_cls1__IjAgV","cls2":"InviteRegisterTOTP-TextFieldContainer_cls2__XeObv InviteRegisterTOTP-TextFieldContainer_cls1__IjAgV"};